import { useEffect, useState } from "react";
import "./index.css";
import { Sidebar } from "../../components/sidebar";
import { Wrapper } from "../../components/wrapper";
import { findMechanics } from "../../services/user";
import { findById } from "../../services/car";
import { DEFAULT_SNACK } from "../../utils/snacks";
import { DEFAULT_CAR, SERVICES_COLUMNS } from "../../utils/states";
import car from "./data.json";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";

import { exportPdf, openPdf, publicPdf } from "../../services/files";
import { Spinner } from "../../components/spinner";

export const PDFViewer = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(DEFAULT_CAR);
  const [uri, setUri] = useState(null);
  const [snack, setSnackbar] = useState(DEFAULT_SNACK);
  /*   const [models, setModels] = useState([]); */
  const [services, setServices] = useState(car.services);
  /*   const [, setWorker] = useState(null); */
  const [, /* searchedRegister */ setSearchedRegister] = useState(false);
  const [, /* idRegister */ setIdRegister] = useState(null);
  /*   const [servicesColumns, setServicesColumns] = useState(SERVICES_COLUMNS); */
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    findMechanics().then((data) => {
      /*      setModels(data); */

      let newdata = {};
      for (const worker of data) {
        newdata[
          `${worker.name} ${worker.last_name}`
        ] = `${worker.name} ${worker.last_name}`;
      }
      let workerIndex = SERVICES_COLUMNS.findIndex((o) => o.field === "worker");
      SERVICES_COLUMNS[workerIndex] = {
        ...SERVICES_COLUMNS[workerIndex],
        lookup: newdata,
      };
    });
  }, []);
  /* 
  useEffect(() => {
    if (location.search === "") {
      navigate("/");
    }
  }, [location.search]); */

  useEffect(() => {
    if (window.location.search) {
      async function fetchRegister() {
        try {
          let id = window.location.search.split("?")[1];

          let fileRegister = await findById(id);
          let fileServices = fileRegister.services || [];

          setData({
            ...data,
            license: fileRegister.license,
            customer_name: fileRegister.customer_name,
            customer_id: fileRegister.customer_id,
            phone: fileRegister.phone,
            brand: fileRegister.brand,
            model: fileRegister.model,
            kms: fileRegister.kms,
            date: fileRegister.date,
          });
          setServices(fileServices);
          setSearchedRegister(true);
          setIdRegister(id);
          setLoading(false);
        } catch (err) {
          console.log(err);
        }
      }
      fetchRegister();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!loading) {
      let url = openPdf(SERVICES_COLUMNS, services, data.kms, data);
      setUri(url);
      publicPdf(SERVICES_COLUMNS, services, data.kms, data);
    }
  }, [loading]);

  /*   function downloadPDF() {
    exportPdf(SERVICES_COLUMNS, services, data.kms, data);
  } */

  return (
    <div
      style={{ backgroundColor: "#111827", width: "100vw", height: "100vh" }}
    >
      {loading && <Spinner />}
      <object
        data={uri}
        type="application/pdf"
        width="100%"
        height="100%"
        aria-label="PDF"
      >
        <a href={uri} download="GeneratedDocument.pdf">
          Descargar PDF
        </a>
      </object>
      <img
        style={{ visibility: "hidden" }}
        id="logo-pdf"
        src={logo}
        height="20"
        width={20}
        alt="..."
      />
    </div>
  );
};
